import React from 'react';
import SignatureFunctional from './Components/signatureFunctional';

const SignaturePage = ({ allowNavigate, buttonMode }) => {
	return <SignatureFunctional allowNavigate={allowNavigate} buttonMode={buttonMode} />;
};
export default SignaturePage;
